import Vue from "vue"
// import axios from "axios" // <-- WIRD NICHT MEHR GEBRAUCHT
import socketService from "@/socketService"
import api from "@/api" // <-- DAS IST JETZT UNSERE QUELLE

const state = {
  // (State bleibt 1:1 gleich)
  chatGroups: [],
  chatMessages: {},
  activeGroupId: null,
  isLoadingGroups: false,
  isLoadingMessages: false,
  userPresence: {},
  replyingToMessage: null,
  editingMessage: null,
  viewedUserProfile: null, // Hält das User-Objekt für das Popup
  commonGroups: [], // Hält die gemeinsamen Gruppen
  isLoadingProfile: false, // Lade-Spinner für das Popup
  typingUsers: {},
  globalToastMessage: null,
  loadedGroupHistories: [],
}

const mutations = {
  UPDATE_GROUP_ON_NEW_MESSAGE(state, { message, myUserId }) {
    const groupId = message.groupId.toString()
    const group = state.chatGroups.find((g) => g._id === groupId)
    if (group) {
      // 1. Aktualisiere die 'letzte Nachricht' (DAS IST DER FIX FÜR DICH)
      Vue.set(group, "lastMessage", message) // 2. Prüfe auf Badges (nur wenn es nicht meine eigene Nachricht ist)

      if (message.senderId._id !== myUserId) {
        Vue.set(group, "hasUnread", true) // 3. Prüfe auf @Mentions
        const isMentioned = (message.mentions || []).some((mentionId) => (mentionId._id || mentionId) === myUserId)
        if (isMentioned) {
          Vue.set(group, "isMentioned", true)
        }
      }

      // 4. "Richtig Geil"-Bonus: Sortiere die Liste neu
      state.chatGroups.sort((a, b) => {
        if (!a.lastMessage) return 1
        if (!b.lastMessage) return -1
        return new Date(b.lastMessage.createdAt) - new Date(a.lastMessage.createdAt)
      })
    }
  }, // NEU:
  MARK_GROUP_READ(state, { groupId }) {
    const group = state.chatGroups.find((g) => g._id === groupId)
    if (group) {
      Vue.set(group, "hasUnread", false)
      Vue.set(group, "isMentioned", false)
    }
  },
  MARK_HISTORY_LOADED(state, groupId) {
    if (!state.loadedGroupHistories.includes(groupId)) {
      state.loadedGroupHistories.push(groupId)
    }
  },
  REMOVE_GROUP_FROM_LIST(state, groupId) {
    state.chatGroups = state.chatGroups.filter((g) => g._id !== groupId)
    // Wenn es die aktive Gruppe war, schließe das Chat-Fenster
    if (state.activeGroupId === groupId) {
      state.activeGroupId = null
    }
  },
  SET_GLOBAL_TOAST(state, message) {
    // message kann 'null' oder ein Objekt sein
    state.globalToastMessage = message
  },
  ADD_TYPING_USER(state, { groupId, userId }) {
    if (!state.typingUsers[groupId]) {
      Vue.set(state.typingUsers, groupId, [])
    }
    const isAlreadyTyping = state.typingUsers[groupId].includes(userId)
    if (!isAlreadyTyping) {
      state.typingUsers[groupId].push(userId) // <-- Pushe nur die ID
    }
  },

  REMOVE_TYPING_USER(state, { groupId, userId }) {
    if (state.typingUsers[groupId]) {
      const newList = state.typingUsers[groupId].filter((id) => id !== userId) // <-- Filtere nach ID
      Vue.set(state.typingUsers, groupId, newList)
    }
  },
  SET_VIEWED_PROFILE(state, user) {
    state.viewedUserProfile = user
    if (user) {
      state.isLoadingProfile = true // Lade-Spinner starten
      state.commonGroups = [] // Alte Gruppen-Infos löschen
    }
  },
  SET_COMMON_GROUPS(state, groups) {
    state.commonGroups = groups
    state.isLoadingProfile = false // Lade-Spinner stoppen
  },
  UPDATE_MESSAGES_READ_STATUS(state, { groupId, readByUserId, readerInfo, messageIds, readAt }) {
    const messagesInGroup = state.chatMessages[groupId]
    if (!messagesInGroup) return

    messageIds.forEach((msgId) => {
      const message = messagesInGroup.find((m) => m._id === msgId)
      if (message) {
        // Sicherstellen, dass das Array existiert
        if (!message.readBy) {
          Vue.set(message, "readBy", [])
        } // Prüfen, ob schon drin (sollte nicht, aber sicher ist sicher)
        const alreadyRead = message.readBy.some((r) => (r.userId._id || r.userId) === readByUserId)
        if (!alreadyRead) {
          message.readBy.push({
            userId: readerInfo || { _id: readByUserId }, // Pushed das { _id, vorname, bild } Objekt
            readAt: readAt,
          })
        }
      }
    })
  },
  SET_GROUP_MEMBERS(state, { groupId, members }) {
    const group = state.chatGroups.find((g) => g._id === groupId)
    if (group) {
      // Vue.set ist wichtig für die Reaktivität von Objekt-Properties
      Vue.set(group, "members", members)
    }
  },
  SET_EDITING_MESSAGE(state, message) {
    // message kann auch 'null' sein
    state.editingMessage = message

    // Wichtig: Editieren und Antworten schließen sich gegenseitig aus
    if (message) {
      state.replyingToMessage = null
    }
  },
  UPDATE_GROUP_DETAILS(state, updatedGroup) {
    const index = state.chatGroups.findIndex((g) => g._id === updatedGroup._id)
    if (index !== -1) {
      // Wir müssen die 'members' behalten, falls sie nicht mitgeschickt wurden
      const oldGroup = state.chatGroups[index]
      const newGroup = { ...oldGroup, ...updatedGroup }
      Vue.set(state.chatGroups, index, newGroup)
    }
    // Wenn es die aktive Gruppe ist, update auch die activeGroupData (im Getter)
    if (state.activeGroupId === updatedGroup._id) {
      // Das passiert automatisch, da der Getter reaktiv ist.
    }
  },
  // (Mutations bleiben 1:1 gleich)
  SET_REPLYING_TO(state, message) {
    // message kann auch 'null' sein
    state.replyingToMessage = message
  },
  UPDATE_MESSAGE(state, updatedMessage) {
    const groupId = updatedMessage.groupId.toString()
    if (!state.chatMessages[groupId]) return

    const index = state.chatMessages[groupId].findIndex((m) => m._id === updatedMessage._id)
    if (index !== -1) {
      // Vue.set ist nötig, um die Reaktivität im Array zu triggern
      Vue.set(state.chatMessages[groupId], index, updatedMessage)
    }
  },
  SET_ACTIVE_GROUP_ID(state, groupId) {
    state.activeGroupId = groupId
  }, // NEU: Setzt/Updated den Status für einen User

  SET_USER_PRESENCE(state, { userId, isOnline, lastSeen }) {
    Vue.set(state.userPresence, userId, { isOnline, lastSeen })
  },
  SET_LOADING_GROUPS(state, isLoading) {
    state.isLoadingGroups = isLoading
  },
  SET_LOADING_MESSAGES(state, isLoading) {
    state.isLoadingMessages = isLoading
  },
  SET_GROUPS(state, groups) {
    state.chatGroups = groups
  },
  SET_MESSAGES(state, { groupId, messages }) {
    Vue.set(state.chatMessages, groupId, messages)
  },
  ADD_MESSAGE(state, message) {
    const groupId = message.groupId.toString()
    if (!state.chatMessages[groupId]) {
      Vue.set(state.chatMessages, groupId, [])
    }
    const exists = state.chatMessages[groupId].some((m) => m._id === message._id)
    if (!exists) {
      state.chatMessages[groupId].push(message)
    }
  },
  ADD_GROUP(state, group) {
    const exists = state.chatGroups.some((g) => g._id === group._id)
    if (!exists) {
      state.chatGroups.unshift(group)
    }
  },
  SET_ACTIVE_GROUP_ID(state, groupId) {
    state.activeGroupId = groupId
  },
}

const actions = {
  async forwardMessage({ commit, state }, { message, targetGroupIds }) {
    const payload = {
      targetGroupIds: targetGroupIds,
      messageData: {
        textContent: message.textContent,
        isForwarded: true, // <-- Hier setzen wir das Flag!
        isBroadcast: false,
      },
    }
    socketService.socket.emit("chat:multicastMessage", payload) // (Wir brauchen kein 'await', das läuft im Hintergrund)
  },
  async leaveGroup({ commit }, groupId) {
    try {
      // 1. API aufrufen
      await api.leaveChatGroup(groupId) // 2. Store-Mutation aufrufen
      commit("REMOVE_GROUP_FROM_LIST", groupId)
    } catch (err) {
      console.error("Fehler beim Verlassen der Gruppe:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  showGlobalToast({ commit }, message) {
    // 1. Die Nachricht sofort anzeigen
    commit("SET_GLOBAL_TOAST", message)

    // 2. Die Nachricht nach 5 Sekunden automatisch ausblenden
    setTimeout(() => {
      // (Wir prüfen, ob es noch dieselbe Nachricht ist,
      // falls in der Zwischenzeit 10 neue kamen)
      if (state.globalToastMessage && state.globalToastMessage._id === message._id) {
        commit("SET_GLOBAL_TOAST", null)
      }
    }, 5000) // 5 Sekunden
  },
  emitStartTyping({ state }) {
    const groupId = state.activeGroupId
    if (groupId) {
      socketService.socket.emit("chat:startTyping", { groupId })
    }
  },

  // 2. Wird vom UI aufgerufen, WENN ICH aufhöre zu tippen
  emitStopTyping({ state }) {
    const groupId = state.activeGroupId
    if (groupId) {
      socketService.socket.emit("chat:stopTyping", { groupId })
    }
  },

  // 3. Wird von App.vue aufgerufen, WENN ANDERE tippen
  handleUserStartedTyping({ commit }, payload) {
    commit("ADD_TYPING_USER", payload)
  },

  // 4. Wird von App.vue aufgerufen, WENN ANDERE aufhören
  handleUserStoppedTyping({ commit }, payload) {
    commit("REMOVE_TYPING_USER", payload)
  },
  async viewUserProfile({ commit }, user) {
    commit("SET_VIEWED_PROFILE", user) // Öffnet das Popup

    try {
      // 1. API aufrufen
      const { data: groups } = await api.fetchCommonGroups(user._id)
      // 2. Store-Mutation aufrufen
      commit("SET_COMMON_GROUPS", groups)
    } catch (err) {
      console.error("Fehler beim Laden der gemeinsamen Gruppen:", err)
      commit("SET_COMMON_GROUPS", []) // Leeres Array bei Fehler
    }
  },
  closeUserProfile({ commit }) {
    commit("SET_VIEWED_PROFILE", null)
  },
  sendReadReceipts({ state }, { groupId, messageIds }) {
    const payload = {
      groupId,
      messageIds,
    }
    socketService.socket.emit("chat:messagesRead", payload)
  },
  handleSocketMessagesRead({ commit }, payload) {
    commit("UPDATE_MESSAGES_READ_STATUS", payload)
  },
  async addMembersToGroup({ commit }, { groupId, memberIds }) {
    try {
      // 1. API aufrufen (gibt die *neue, populierte* Mitgliederliste zurück)
      const { data: newMembersList } = await api.addChatMembers(groupId, memberIds) // 2. Store-Mutation aufrufen
      commit("SET_GROUP_MEMBERS", { groupId, members: newMembersList }) // 3. TODO: Socket-Event 'chat:memberAdded' an die neuen User senden
    } catch (err) {
      console.error("Fehler beim Hinzufügen von Mitgliedern:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  async kickGroupMember({ commit }, { groupId, userIdToRemove }) {
    try {
      // 1. API aufrufen (gibt die *neue* Mitgliederliste zurück)
      const { data: newMembersList } = await api.kickChatMember(groupId, userIdToRemove) // 2. Store-Mutation aufrufen
      commit("SET_GROUP_MEMBERS", { groupId, members: newMembersList }) // 3. TODO: Socket-Event 'chat:memberKicked' an alle senden
    } catch (err) {
      console.error("Fehler beim Entfernen des Mitglieds:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  async updateGroupMemberRole({ commit }, { groupId, userIdToUpdate, newRole }) {
    try {
      // 1. API aufrufen (gibt die *neue* Mitgliederliste zurück)
      const { data: newMembersList } = await api.updateChatMemberRole(groupId, userIdToUpdate, newRole) // 2. Store-Mutation aufrufen
      commit("SET_GROUP_MEMBERS", { groupId, members: newMembersList }) // 3. TODO: Socket-Event 'chat:roleUpdated' an alle senden
    } catch (err) {
      console.error("Fehler beim Ändern der Rolle:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  setReplyTo({ commit }, message) {
    commit("SET_REPLYING_TO", message)
  },
  setEditingMessage({ commit }, message) {
    commit("SET_EDITING_MESSAGE", message)
  },

  /**
   * Bricht die Bearbeitung ab
   */
  cancelEditing({ commit }) {
    commit("SET_EDITING_MESSAGE", null)
  },

  /**
   * Sendet die bearbeitete Nachricht an den Server
   */
  dispatchEditMessage({ commit, state }, payload) {
    // <-- 'payload' statt 'newTextContent'
    if (!state.editingMessage) return
    const finalPayload = {
      groupId: state.editingMessage.groupId,
      messageId: state.editingMessage._id,
      // Wir übergeben das *ganze* Payload-Objekt (mit 'textContent' und 'mentionIds')
      newPayload: payload,
    }
    socketService.socket.emit("chat:editMessage", finalPayload) // Bearbeitungs-Modus beenden
    commit("SET_EDITING_MESSAGE", null)
  },

  async saveGroupDetails({ commit }, { groupId, updateData }) {
    try {
      // 1. API aufrufen
      const { data: updatedGroup } = await api.updateGroup(groupId, updateData)

      // 2. Store-Mutation aufrufen
      commit("UPDATE_GROUP_DETAILS", updatedGroup)

      // 3. TODO: Socket-Event 'chat:groupUpdated' an alle senden
    } catch (err) {
      console.error("Fehler beim Speichern der Gruppe:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  /**
   * Sendet das "Lösch"-Event an den Server
   */
  deleteMessage({ state }, message) {
    const payload = {
      groupId: message.groupId,
      messageId: message._id,
    }
    socketService.socket.emit("chat:deleteMessage", payload)
  },
  async createGroup({ commit, dispatch }, groupData) {
    try {
      // ALT: const { data: newGroup } = await axios.post("/api/chat/groups", groupData)
      // NEU:
      const { data: newGroup } = await api.createGroup(groupData)

      commit("ADD_GROUP", newGroup)
      dispatch("setActiveGroup", newGroup._id)
    } catch (err) {
      console.error("Fehler beim Erstellen der Gruppe:", err.response.data)
      throw err
    }
  },

  async fetchGroups({ commit }) {
    commit("SET_LOADING_GROUPS", true)
    try {
      const { data: groups } = await api.fetchGroups()
      commit("SET_GROUPS", groups) // --- NEU: Initialen Presence-Status aus den Gruppen füllen ---

      if (groups) {
        groups.forEach((group) => {
          ;(group.members || []).forEach((member) => {
            if (member.userId) {
              // Sicherstellen, dass der User da ist
              commit("SET_USER_PRESENCE", {
                userId: member.userId._id,
                isOnline: member.userId.isOnline,
                lastSeen: member.userId.lastSeen,
              })
            }
          })
        })
      } // --- ENDE NEU ---
    } catch (err) {
      console.error("Fehler beim Laden der Chat-Gruppen:", err)
    } finally {
      commit("SET_LOADING_GROUPS", false)
    }
  },

  async fetchMessagesForGroup({ commit }, groupId) {
    commit("SET_LOADING_MESSAGES", true)
    try {
      const { data } = await api.fetchMessagesForGroup(groupId)
      commit("SET_MESSAGES", { groupId, messages: data })
      commit("MARK_HISTORY_LOADED", groupId)
    } catch (err) {
      console.error(`Fehler beim Laden der Nachrichten für ${groupId}:`, err)
    } finally {
      commit("SET_LOADING_MESSAGES", false)
    }
  },
  handleUserOnline({ commit }, payload) {
    commit("SET_USER_PRESENCE", {
      userId: payload.userId,
      isOnline: true,
    })
  },
  /**
   * Wird von App.vue aufgerufen (Socket 'chat:userOffline')
   */ handleUserOffline({ commit }, payload) {
    commit("SET_USER_PRESENCE", {
      userId: payload.userId,
      isOnline: false,
      lastSeen: payload.lastSeen,
    })
  },
  async setActiveGroup({ commit, state, dispatch }, groupId) {
    commit("SET_ACTIVE_GROUP_ID", groupId)
    if (!groupId) {
      return
    }
    dispatch("markGroupAsRead", groupId) // (Dein 'loadedGroupHistories'-Check bleibt gleich)

    if (!state.loadedGroupHistories.includes(groupId)) {
      await dispatch("fetchMessagesForGroup", groupId)
    }
  },
  sendMessage({ state, commit }, messagePayload) {
    // <-- 'commit' hinzugefügt
    if (!state.activeGroupId) return console.error("...")
    const payload = {
      ...messagePayload, // Enthält jetzt { textContent, messageType, mentionIds }
      groupId: state.activeGroupId,
      replyToMessageId: state.replyingToMessage ? state.replyingToMessage._id : null,
    }
    socketService.socket.emit("chat:sendMessage", payload)
    if (state.replyingToMessage) {
      commit("SET_REPLYING_TO", null)
    }
  },

  handleSocketNewMessage({ commit, rootState }, message) {
    // <-- 'rootState' hinzugefügt
    // 1. Füge Nachricht zum Chat-Fenster hinzu (bleibt gleich)
    commit("ADD_MESSAGE", message)

    // 2. Hol die ID des eingeloggten Users
    const myUserId = rootState.userStore.user._id

    // 3. Aktualisiere die Gruppen-VORSCHAU (Badge, Text, Sortierung)
    commit("UPDATE_GROUP_ON_NEW_MESSAGE", { message, myUserId })
  },
  /**
   * Teilt dem Server mit, dass wir diesen Chat JETZT gelesen haben.
   * (ANGEPASST)
   */ markGroupAsRead({ commit, state }, groupId) {
    if (!groupId) return
    socketService.socket.emit("chat:markGroupRead", { groupId }) // ALT: commit('UPDATE_GROUP_UNREAD_STATUS', { groupId, isRead: true });
    // NEU:
    commit("MARK_GROUP_READ", { groupId })
  },

  handleSocketGroupAdded({ commit, dispatch }, group) {
    commit("ADD_GROUP", group)
  },
  handleSocketMessageUpdated({ commit }, updatedMessage) {
    commit("UPDATE_MESSAGE", updatedMessage)
  },
}

const getters = {
  // (Getters bleiben 1:1 gleich)
  getTypingUsersForActiveGroup: (state, getters) => {
    // <-- Wir brauchen 'getters'
    const activeGroupId = state.activeGroupId
    const activeGroup = getters.activeGroupData // Den Getter haben wir schon!

    // 2. Hol die Liste der tippenden IDs für diese Gruppe
    const typingIds = state.typingUsers[activeGroupId] || []

    if (!activeGroup || !activeGroup.members || typingIds.length === 0) {
      return [] // Nichts zu tun
    }

    return activeGroup.members.filter((member) => typingIds.includes(member.userId._id))
  },
  activeGroupMessages: (state) => {
    return state.chatMessages[state.activeGroupId] || []
  },
  activeGroupData: (state) => {
    return state.chatGroups.find((g) => g._id === state.activeGroupId)
  },
  getPresenceByUserId: (state) => (userId) => {
    return state.userPresence[userId] || { isOnline: false }
  },
}

export const chatStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
